// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/boundarypb/v1/boundary.proto (package unacast.boundaries.boundarypb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Geometry } from "../../../../mapbox/geobuf/v1/geobuf_pb.js";
import { MetadataType } from "../../typesetpb/v1/typeset_pb.js";

/**
 * @generated from enum unacast.boundaries.boundarypb.v1.MetadataValueVariant
 */
export enum MetadataValueVariant {
  /**
   * @generated from enum value: METADATA_VALUE_VARIANT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METADATA_VALUE_VARIANT_FREEFORM = 1;
   */
  FREEFORM = 1,

  /**
   * @generated from enum value: METADATA_VALUE_VARIANT_ENFORCED = 2;
   */
  ENFORCED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(MetadataValueVariant)
proto3.util.setEnumType(MetadataValueVariant, "unacast.boundaries.boundarypb.v1.MetadataValueVariant", [
  { no: 0, name: "METADATA_VALUE_VARIANT_UNSPECIFIED" },
  { no: 1, name: "METADATA_VALUE_VARIANT_FREEFORM" },
  { no: 2, name: "METADATA_VALUE_VARIANT_ENFORCED" },
]);

/**
 * @generated from message unacast.boundaries.boundarypb.v1.Boundary
 */
export class Boundary extends Message<Boundary> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: mapbox.geobuf.v1.Geometry polygon = 2;
   */
  polygon?: Geometry;

  /**
   * @generated from field: unacast.boundaries.boundarypb.v1.BoundaryMetadata metadata = 10;
   */
  metadata?: BoundaryMetadata;

  /**
   * Audit fields
   *
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string principal_email = 22;
   */
  principalEmail = "";

  /**
   * Version tracking
   *
   * @generated from field: bool in_draft = 23;
   */
  inDraft = false;

  /**
   * @generated from field: optional int32 version_added = 24;
   */
  versionAdded?: number;

  /**
   * @generated from field: optional int32 version_removed = 25;
   */
  versionRemoved?: number;

  constructor(data?: PartialMessage<Boundary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.boundarypb.v1.Boundary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "polygon", kind: "message", T: Geometry },
    { no: 10, name: "metadata", kind: "message", T: BoundaryMetadata },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
    { no: 21, name: "updated_at", kind: "message", T: Timestamp },
    { no: 22, name: "principal_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "in_draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "version_added", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 25, name: "version_removed", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Boundary {
    return new Boundary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Boundary {
    return new Boundary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Boundary {
    return new Boundary().fromJsonString(jsonString, options);
  }

  static equals(a: Boundary | PlainMessage<Boundary> | undefined, b: Boundary | PlainMessage<Boundary> | undefined): boolean {
    return proto3.util.equals(Boundary, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.boundarypb.v1.Point
 */
export class Point extends Message<Point> {
  /**
   * @generated from field: double lat = 1;
   */
  lat = 0;

  /**
   * @generated from field: double long = 2;
   */
  long = 0;

  constructor(data?: PartialMessage<Point>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.boundarypb.v1.Point";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "long", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Point {
    return new Point().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Point {
    return new Point().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Point {
    return new Point().fromJsonString(jsonString, options);
  }

  static equals(a: Point | PlainMessage<Point> | undefined, b: Point | PlainMessage<Point> | undefined): boolean {
    return proto3.util.equals(Point, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.boundarypb.v1.MetadataValue
 */
export class MetadataValue extends Message<MetadataValue> {
  /**
   * @generated from field: unacast.boundaries.boundarypb.v1.MetadataValueVariant variant = 1;
   */
  variant = MetadataValueVariant.UNSPECIFIED;

  /**
   * @generated from oneof unacast.boundaries.boundarypb.v1.MetadataValue.data
   */
  data: {
    /**
     * @generated from field: string freeform = 5;
     */
    value: string;
    case: "freeform";
  } | {
    /**
     * @generated from field: unacast.boundaries.typesetpb.v1.MetadataType enforced = 6;
     */
    value: MetadataType;
    case: "enforced";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<MetadataValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.boundarypb.v1.MetadataValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "variant", kind: "enum", T: proto3.getEnumType(MetadataValueVariant) },
    { no: 5, name: "freeform", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "data" },
    { no: 6, name: "enforced", kind: "message", T: MetadataType, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetadataValue {
    return new MetadataValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetadataValue {
    return new MetadataValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetadataValue {
    return new MetadataValue().fromJsonString(jsonString, options);
  }

  static equals(a: MetadataValue | PlainMessage<MetadataValue> | undefined, b: MetadataValue | PlainMessage<MetadataValue> | undefined): boolean {
    return proto3.util.equals(MetadataValue, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.boundarypb.v1.OpeningHours
 */
export class OpeningHours extends Message<OpeningHours> {
  /**
   * @generated from field: repeated string monday = 1 [json_name = "Monday"];
   */
  monday: string[] = [];

  /**
   * @generated from field: repeated string tuesday = 2 [json_name = "Tuesday"];
   */
  tuesday: string[] = [];

  /**
   * @generated from field: repeated string wednesday = 3 [json_name = "Wednesday"];
   */
  wednesday: string[] = [];

  /**
   * @generated from field: repeated string thursday = 4 [json_name = "Thursday"];
   */
  thursday: string[] = [];

  /**
   * @generated from field: repeated string friday = 5 [json_name = "Friday"];
   */
  friday: string[] = [];

  /**
   * @generated from field: repeated string saturday = 6 [json_name = "Saturday"];
   */
  saturday: string[] = [];

  /**
   * @generated from field: repeated string sunday = 7 [json_name = "Sunday"];
   */
  sunday: string[] = [];

  constructor(data?: PartialMessage<OpeningHours>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.boundarypb.v1.OpeningHours";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "monday", jsonName: "Monday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "tuesday", jsonName: "Tuesday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "wednesday", jsonName: "Wednesday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "thursday", jsonName: "Thursday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "friday", jsonName: "Friday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "saturday", jsonName: "Saturday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "sunday", jsonName: "Sunday", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpeningHours {
    return new OpeningHours().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpeningHours {
    return new OpeningHours().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpeningHours {
    return new OpeningHours().fromJsonString(jsonString, options);
  }

  static equals(a: OpeningHours | PlainMessage<OpeningHours> | undefined, b: OpeningHours | PlainMessage<OpeningHours> | undefined): boolean {
    return proto3.util.equals(OpeningHours, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.boundarypb.v1.BoundaryMetadata
 */
export class BoundaryMetadata extends Message<BoundaryMetadata> {
  /**
   * @generated from field: optional string display_name = 1;
   */
  displayName?: string;

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.MetadataValue category = 2;
   */
  category?: MetadataValue;

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.MetadataValue brand = 3;
   */
  brand?: MetadataValue;

  /**
   * @generated from field: optional bool includes_parking = 4;
   */
  includesParking?: boolean;

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.OpeningHours opening_hours = 5;
   */
  openingHours?: OpeningHours;

  /**
   * @generated from field: optional string notes = 6;
   */
  notes?: string;

  /**
   * Centroid
   *
   * @generated from field: optional unacast.boundaries.boundarypb.v1.Point centroid = 10;
   */
  centroid?: Point;

  /**
   * @generated from field: optional double radius = 11;
   */
  radius?: number;

  /**
   * Address
   *
   * @generated from field: optional unacast.boundaries.boundarypb.v1.MetadataValue street_address = 12;
   */
  streetAddress?: MetadataValue;

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.MetadataValue country = 13;
   */
  country?: MetadataValue;

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.MetadataValue city = 14;
   */
  city?: MetadataValue;

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.MetadataValue admin_level = 15;
   */
  adminLevel?: MetadataValue;

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.MetadataValue postal_code = 18;
   */
  postalCode?: MetadataValue;

  /**
   * Existence dates (ISO 8601 date format: YYYY-MM-DD)
   *
   * @generated from field: optional string came_into_existence = 19;
   */
  cameIntoExistence?: string;

  /**
   * @generated from field: optional string ceased_to_exist = 20;
   */
  ceasedToExist?: string;

  /**
   * @generated from field: optional string client_provided_id = 30;
   */
  clientProvidedId?: string;

  /**
   * Additional custom properties as key-value pairs
   *
   * @generated from field: map<string, string> additional_properties = 31;
   */
  additionalProperties: { [key: string]: string } = {};

  constructor(data?: PartialMessage<BoundaryMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.boundarypb.v1.BoundaryMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "category", kind: "message", T: MetadataValue, opt: true },
    { no: 3, name: "brand", kind: "message", T: MetadataValue, opt: true },
    { no: 4, name: "includes_parking", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "opening_hours", kind: "message", T: OpeningHours, opt: true },
    { no: 6, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "centroid", kind: "message", T: Point, opt: true },
    { no: 11, name: "radius", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 12, name: "street_address", kind: "message", T: MetadataValue, opt: true },
    { no: 13, name: "country", kind: "message", T: MetadataValue, opt: true },
    { no: 14, name: "city", kind: "message", T: MetadataValue, opt: true },
    { no: 15, name: "admin_level", kind: "message", T: MetadataValue, opt: true },
    { no: 18, name: "postal_code", kind: "message", T: MetadataValue, opt: true },
    { no: 19, name: "came_into_existence", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "ceased_to_exist", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 30, name: "client_provided_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 31, name: "additional_properties", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BoundaryMetadata {
    return new BoundaryMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BoundaryMetadata {
    return new BoundaryMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BoundaryMetadata {
    return new BoundaryMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: BoundaryMetadata | PlainMessage<BoundaryMetadata> | undefined, b: BoundaryMetadata | PlainMessage<BoundaryMetadata> | undefined): boolean {
    return proto3.util.equals(BoundaryMetadata, a, b);
  }
}

